import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ArrowLeft, ArrowRight, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const insights = [
    {
        id: 1,
        title: "AI agents in cloud environments—security essentials",
        description: "A retail chain used AI personalization to better connect with customers, improving engagement and growing sales by 25%.",
        image: "/assets/what/c9.jpg",
        category: "Cloud Security",
        link: "/contact",
    },
    {
        id: 2,
        title: "AI agents in cloud environments—security essentials",
        description: "A logistics company upgraded its old systems into a modern digital platform, making operations smoother and boosting efficiency by 40%.",
        image: "/assets/home-/img2.png",
        category: "Strategy",
        link: "/contact",
    },
    {
        id: 3,
        title: "AI agents in cloud environments—security essentials",
        description: "A food and beverage company cut energy costs by 20% while also strengthening its ESG goals using cloud-native applications.",
        image: "/assets/home-/img3.png",
        category: "Data Science",
        link: "/contact",
    },
    {
        id: 4,
        title: "Optimizing Supply Chain With Cloud ERP",
        description: "A global manufacturer successfully reduced operational costs by 30% after we implemented a scalable Infor M3 ERP solution tailored to their needs.",
        image: "/assets/service-detail/img10.png",
        category: "Security",
        link: "/contact",
    },
    {
        id: 5,
        title: "Accelerating Time-to-Market With DevOps",
        description: "A fintech startup was able to release products 50% faster after adopting our CI/CD and DevOps automation setup, making their development process smoother and more efficient.",
        image: "/assets/service-detail/img11.png",
        category: "Security",
        link: "/contact",
    },
];

const LatestInsightsSection = () => {
    const [loaded, setLoaded] = useState(false);

    const firstFixedCard = insights[0];
    const sliderCards = insights.slice(1);

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            created() {
                setLoaded(true);
            },
            loop: true,
            mode: "snap",
            slides: {
                perView: 1.15,
                spacing: 10,
            },
            breakpoints: {
                "(min-width: 640px)": { slides: { perView: 1.5, spacing: 16 } },
                "(min-width: 1024px)": { slides: { perView: 2, spacing: 16 } },
            },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;
                function clearNextTimeout() {
                    clearTimeout(timeout);
                }
                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }
                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseout", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="relative w-full py-[70px] lg:py-[100px] overflow-hidden" style={{ background: "linear-gradient(0deg, #002F8D 0%, #000000 100%)" }}>
            <div className="absolute left-1/2 -translate-x-1/2 top-[41px]">
                <img src="/assets/home/wrap1.png" className="w-full h-full object-cover max-w-[1020px]" alt="" />
            </div>
            {/* <div
                className="absolute inset-0 pointer-events-none z-0"
                style={{
                    background:
                        "radial-gradient(circle at 10% 50%, rgba(0, 43, 128, 0.45) 0%, transparent 60%)",
                }}
            />
            <div
                className="absolute inset-0 pointer-events-none z-0 opacity-40"
                style={{
                    clipPath: "polygon(25% 0%, 100% 0%, 100% 100%, 0% 100%)",
                    background:
                        "linear-gradient(135deg, rgba(0, 56, 150, 0.5) 0%, rgba(1, 24, 60, 0.95) 75%)",
                }}
            /> */}

            <div className="relative z-10 max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="flex items-center justify-between mb-[36px] lg:mb-[48px]">
                    <h2 className="font-sora text-[24px] sm:text-[30px] lg:text-[36px] font-[600] text-white tracking-tight leading-[1.2]">
                        Latest Insights
                    </h2>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-3">
                            <button
                                type="button"
                                onClick={(e) =>
                                    e.stopPropagation() || instanceRef.current?.prev()
                                }
                                aria-label="Previous Slide"
                                className="w-[38px] h-[38px] sm:w-[42px] sm:h-[42px] rounded-full border border-white/40 text-white flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 active:scale-95 cursor-pointer"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            <button
                                type="button"
                                onClick={(e) =>
                                    e.stopPropagation() || instanceRef.current?.next()
                                }
                                aria-label="Next Slide"
                                className="w-[38px] h-[38px] sm:w-[42px] sm:h-[42px] rounded-full border border-white/40 text-white flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 active:scale-95 cursor-pointer"
                            >
                                <ArrowRight size={18} />
                            </button>
                        </div>
                    )}
                </div>

                <div className="flex flex-col lg:flex-row gap-[10px] lg:gap-[16px] items-stretch">

                    <div className="w-full lg:w-[50%] min-w-0">
                        <div ref={sliderRef} className="keen-slider h-full">
                            {sliderCards.map((item) => (
                                <div key={item.id} className="keen-slider__slide h-full">
                                    <InsightCard item={item} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="w-full lg:w-[50%] flex-shrink-0">
                        <InsightCard item={firstFixedCard} />
                    </div>

                </div>
            </div>
        </section>
    );
};

const InsightCard = ({ item }) => {
    return (
        <div className="flex flex-col h-full bg-white overflow-hidden shadow-[0_12px_35px_rgba(0,0,0,0.35)] group transition-all duration-300 hover:-translate-y-1">
            <div className="h-[210px] sm:h-[191px] w-full overflow-hidden bg-slate-900 relative">
                <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
            </div>

            <div className="bg-white p-6 sm:p-7 flex flex-col justify-between flex-grow min-h-[140px]">
                <h3 className="font-sora text-[16px] lg:text-[20px] font-[600] text-[#01386A] leading-[1.35] tracking-tight">
                    {item.title}
                </h3>
            </div>

            <div className="bg-[#002D7A] px-6 py-4 flex items-center">
                <Link
                    to={item.link || "/contact"}
                    className="inline-flex items-center gap-1.5 font-graphik text-[13px] sm:text-[14px] font-[500] text-white underline underline-offset-4 hover:text-[#ED6800] transition-colors"
                >
                    <span>Explore</span>
                    <ChevronRight size={15} />
                </Link>
            </div>
        </div>
    );
};

export default LatestInsightsSection;